import { styled } from '@mui/material';
import { Typography } from 'core/common/ui/ui-kit';

export const TitleStyled = styled(Typography)`
  margin-bottom: 20px;
  text-align: center;
  ${({ theme }) => theme.breakpoints.up('mobile')} {
    margin-bottom: 40px;
  }
`;
